export default{
    fr:{

        //Créer un AO_33
        'Données entreprise':'Données entreprise',
        'Données projet':'Données projet',
        'Exigences projet':'Exigences projet',
        'Confidentielle':'Confidentielle',
        'Masquer le nom de l\'entreprise':'Masquer le nom de l\'entreprise',
        'Manager opérationnel du projet':'Manager opérationnel du projet',
        'Nom et Prénom':'Nom et Prénom',
        'Détails de la publication':'Détails de la publication',
        'Référence interne':'Référence interne',
        'Date de début (publication)':'Date de début (publication)',
        'Date de fin (publication)':'Date de fin (publication)',
        'Données générales':'Données générales',
        'Nombre de recrutés':'Nombre de recrutés',
        'Localisation (pays)' :'Localisation (pays)',
        'Régime de travail':'Régime de travail',
        'Nb de jours/semaine':'Nb de jours/semaine',
        'Mode de travail':'Mode de travail',
        'A distance':'A distance',
        'En présentiel':'En présentiel',
        'Travail à distance':'Travail à distance',
        'Fréquence (télétravail)':'Fréquence (télétravail)',
        'Minimum d\'années d\'expérience':'Minimum d\'années d\'expérience',
        // 'Catégorie':'Catégorie',
        'Sous catégorie':'Sous catégorie',
        'Sélectionner une catégorie':'Sélectionner une catégorie',
        'Sélectionner une sous catégorie':'Sélectionner une sous catégorie',

        'Durée et budget':'Durée et budget',
        'Date de début (mission)':'Date de début (mission)',
        'Date estimée de fin (mission)':'Date estimée de fin (mission)',
        'Durée de la mission (j)':'Durée de la mission (j)',
        'j':'j',
        // 'Durée du BDC':'Durée du BDC',
        'Budget maximum/jour (en €)':'Budget maximum/jour (en €)',
        'Equivalent par mois': 'Equivalent par mois',
        'Visibilité du budget dans l\'AO':'Visibilité du budget dans l\'AO',
        'Equipe chargée du recrutement et/ou suivi du projet':'Equipe chargée du recrutement et/ou suivi du projet',
        // 'Gestion des candidatures' :'Gestion des candidatures',
        'Suivi projet':'Suivi projet',

        'Compétences techniques':'Compétences techniques',
        'Intermédiaire':'Intermédiaire',
        'Minimum d\'années d\'exp.':'Minimum d\'années d\'exp.',
        'Expérience plus récente':'Expérience plus récente',
        // 'Cette année':'Cette année',
        'Moins de 2 ans':'Moins de 2 ans',
        'Moins de 3 ans':'Moins de 3 ans',
        'Ajouter une compétence':'Ajouter une compétence',
        'Compétences fonctionnelles':'Compétences fonctionnelles',
        'Exigence':'Exigence',
        'Sélectionner un type':'Sélectionner un type',
        'Exigé':'Exigé',
        'Recommandé':'Recommandé',

        'Félicitation!':'Félicitation!',
        'Votre appel d\'offre a été créé avec succès sous la référence':'Votre appel d\'offre a été créé avec succès sous la référence',
        'Une proposition des CVs les plus pertinents correspondant à votre appel d\'offre vous sera liée si des correspondances sont trouvées. Cela peut prendre quelques secondes.': 'Une proposition des CVs les plus pertinents correspondant à votre appel d\'offre vous sera liée si des correspondances sont trouvées. Cela peut prendre quelques secondes.',
        'Si vous souhaitez l\'utiliser comme \'template\' pour publier des besoins similaires à l\'avenir, veuillez cliquer sur \'Template\'.':'Si vous souhaitez l\'utiliser comme \'template\' pour publier des besoins similaires à l\'avenir, veuillez cliquer sur \'Template\'.',
        'Non, merci':'Non, merci',
        'Template':'Template',
        'Définir une template':'Définir une template',
        'Entrer une nom':'Entrer une nom',

        'Votre appel d\'offre a été sauvegardé avec succès sous la référence':'Votre appel d\'offre a été sauvegardé avec succès sous la référence',

        //interface AO et candidatures 34
        'Appels d\'offres ouverts':'Appels d\'offres ouverts',

        'Chercher ici':'Chercher ici',
        'Code int.Client':'Code int.Client',
        'Intitulé':'Intitulé',
        // 'Statut':'Statut',
        'Nb de candidatures':'Nb de candidatures',
        'Nb de recrutement':'Nb de recrutement',
        'Date début souhaitée':'Date début souhaitée',
        'Date fin estimée':'Date fin estimée',
        'Budget Max':'Budget Max',
        'AO créé par':'AO créé par',
        'Resp.opérationnel':'Resp.opérationnel',
        'Début publication':'Début publication',
        'Fin publication':'Fin publication',
        'Annuler la publication':'Annuler la publication',

        // 'Ajouter aux favoris':'Ajouter aux favoris',
        'Changer de statut':'Changer de statut',
        'Transmettre':'Transmettre',
        'Candidatures':'Candidatures',
        'Données AO':'Données AO',
        'Source de candidature':'Source de candidature',
        'Source de Candid':'Source de Candid',
        'Intitulé Du CV':'Intitulé Du CV',
        'Exp.totale':'Exp.totale',
        'Exp. totale':'Exp. totale',
        'Statut candidatures':'Statut candidatures',
        // 'Date de disponibilité':'Date de disponibilité',
        // 'Taux journalier':'Taux journalier',
        'Evaluation':'Evaluation',
        'Commentaires':'Commentaires',
        // 'Date de candidature':'Date de candidature',
        // 'Non lue':'Non lue',
        'Lue':'Lue',
        'Analysée':'Analysée',
        // 'Intéressante':'Intéressante',
        'À interviewer':'À interviewer',
        'Non Retenue':'Non Retenue',
        // 'Retenue':'Retenue',
        // 'BDC signé':'BDC signé',
        'Motif du rejet':'Motif du rejet',
        'Dépasse le budget':'Dépasse le budget',
        'Ne répond pas aux exigences du projet':'Ne répond pas aux exigences du projet',
        'Autre':'Autre',
        'Envoyer':'Envoyer',
        'Rendez-vous':'Rendez-vous',
        'Message':'Message',
        'Ajouter un commentaire':'Ajouter un commentaire',
        'Ajoutez votre commentaire ici':'Ajoutez votre commentaire ici',
        'Date':'Date',
        'Heure':'Heure',
        'Durée de la réunion':'Durée de la réunion',
        // 'Envoyer':'Envoyer',
        'Transmettre des CVs':'Transmettre des CVs',
        'De:':'De:',
        'À:': 'À:',
        'Sujet:':'Sujet:',
        'Vos commentaires privés sur ce CV':'Vos commentaires privés sur ce CV',
        // 'Ajouter':'Ajouter',

        //CV
        'COMPETENCES':'COMPETENCES',
        // 'Compétences techniques':'Compétences techniques',
        // 'Compétences fonctionnelles':'Compétences fonctionnelles',

        //interface 45

        // 'Rendez-vous à venir':'Rendez-vous à venir',
        // 'Aucun rendez-vous pour le moment':'Aucun rendez-vous pour le moment',

        //interface 47
        'Statistiques':'Statistiques',
        'Trafic des utilisateurs':'Trafic des utilisateurs',
        'Trafic par géolocalisation':'Trafic par géolocalisation',

        //interface 48 collaborateurs d\'entreprise
        'Nouveaux inscrits à la plateforme':'Nouveaux inscrits à la plateforme',

        'Flux':'Flux',
        'AO et candidatures':'AO et candidatures',
        'Solde':'Solde',
        'Gestion des experts':'Gestion des experts',
        'Gestion des Experts':'Gestion des Experts',
        'Fiches des experts':'Fiches des experts',
        'Lier les CV selectionnés à un appel d\'offre':'Lier les CV selectionnés à un appel d\'offre',
        'Classer les CV sélectionnés dans un dossier':'Classer les CV sélectionnés dans un dossier',
        'Lier':'Lier',
        'Dossier existant':'Dossier existant',
        'Nouveau dossier':'Nouveau dossier',
        'Entrer le Nom du dossier':'Entrer le Nom du dossier',
        'Classer':'Classer',
        'Renouveler':'Renouveler',
        'Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?':'Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?',
        'Mission annulée':'Mission annulée',
    },
    en:{
        'j':'d',
        'Rendez-vous':'Appointment',
        'Lier les CV selectionnés à un appel d\'offre': 'Link the selected resumes to a call for job',
        'Lier': 'Link',
        'Classer les CV sélectionnés dans un dossier': 'File the selected resumes in a folder',
        'Dossier existant': 'Existing folder',
        'Nouveau dossier': 'New folder',
        'Entrer le Nom du dossier': 'Enter the folder name',
        'Classer':'Create folder',
        'Renouveler':'Renew',
        'Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?':'The notice period to interrupt a mission is at least one month. Do you still want to continue?',
        'Mission annulée':'Mission canceled',
    }
};
